export var AgoricChainStoragePathKind;
(function (AgoricChainStoragePathKind) {
    AgoricChainStoragePathKind["Children"] = "children";
    AgoricChainStoragePathKind["Data"] = "data";
})(AgoricChainStoragePathKind || (AgoricChainStoragePathKind = {}));
